import { hide, show } from '../../util/show'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.min.js'

window.up.compiler('.js-hero_video__wrapper', () => {
  const pageOverlay = document.querySelector('.js-hero_video__page_overlay')
  const iframe = document.querySelector('.js-hero_video__iframe')
  const playButton = document.querySelector('.js-hero_video__play_button')
  const closeButton = document.querySelector('.js-hero_video__close_overlay')
  const closePlayer = function () {
    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'pauseVideo'
      }),
      'https://www.youtube-nocookie.com'
    )
    hide(pageOverlay)
    clearAllBodyScrollLocks()
  }

  pageOverlay && pageOverlay.addEventListener('click', closePlayer)

  playButton &&
    window.up.on(playButton, 'click', undefined, () => {
      show(pageOverlay)
      disableBodyScroll(pageOverlay)
    })

  closeButton &&
    window.up.on(closeButton, 'click', undefined, () => {
      closePlayer()
    })

  return () => {
    clearAllBodyScrollLocks()
  }
})
